import { client } from '@/client';
import { resolveData } from '@/util/api-helpers';

export async function indexCompany({ slug }) {
   return client.get(`/api/capacities/${slug}`)
      .then(resolveData);
}

export async function storeCapacity(company, params) {
   return client.post(`/api/capacities/${company.slug}`, params)
      .then(resolveData);
}

export async function updateCapacity(company, capacity, params) {
   return client.put(`/api/capacities/${company.slug}/${capacity.id}`, params)
      .then(resolveData);
}

export async function reorderCapacities(company, capacities) {
   return client.put(`/api/capacities/${company.slug}/reorder`, {
      order: capacities.map(item => item.id),
   })
      .then(resolveData);
}

export async function deleteCapacity(company, capacity) {
   return client.delete(`/api/capacities/${company.slug}/${capacity.id}`)
      .then(resolveData);
}
